import React, { createContext, useContext, useMemo } from "react";

import { AppConfig } from "../app-config";

interface AppConfigActions {
  setReportLabel: (reportLabel: string) => void;
}

interface AppConfigProviderProps {
  config: AppConfig;
  setReportLabel: (reportLabel: string) => void;
  children: React.ReactNode;
}

const AppConfigStateContext = createContext<AppConfig | null>(null);
const AppConfigActionsContext = createContext<AppConfigActions | null>(null);

export const AppConfigProvider: React.FC<AppConfigProviderProps> = ({
  config,
  setReportLabel,
  children,
}) => {
  const actions = useMemo<AppConfigActions>(() => ({ setReportLabel }), [setReportLabel]);

  return (
    <AppConfigStateContext.Provider value={config}>
      <AppConfigActionsContext.Provider value={actions}>
        {children}
      </AppConfigActionsContext.Provider>
    </AppConfigStateContext.Provider>
  );
};

export function useAppConfig(): AppConfig {
  const context = useContext(AppConfigStateContext);

  if (!context) {
    throw new Error("useAppConfig must be used within AppConfigProvider");
  }

  return context;
}

export function useAppConfigActions(): AppConfigActions {
  const context = useContext(AppConfigActionsContext);

  if (!context) {
    throw new Error("useAppConfigActions must be used within AppConfigProvider");
  }

  return context;
}
